var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"show":_vm.show,"dismissible":"","fade":"","variant":"danger"},on:{"dismissed":function($event){_vm.show = false}}},[_c('div',{staticClass:"alert-body"},[_c('feather-icon',{staticClass:"mr-50",attrs:{"size":"14","icon":"AlertTriangleIcon"}}),_c('span',[_vm._v(_vm._s(_vm.parsedError))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }